import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  Input,
  Injectable,
} from "@angular/core";
import { DashboardService } from "../dashboard.service";
import { appService } from "../../../../app/_services/app.service";
import { ToastrService } from "ngx-toastr";
import { DatePipe } from "@angular/common";
import { moment } from "fullcalendar";
import { google } from "@agm/core/services/google-maps-types";
import { Http, Response } from "@angular/http";
import { TranslateConfigService } from "../../../theme/home/translateConfig.service";
import { TranslateService } from "@ngx-translate/core";
const LNG_KEY = "SELECTED_LANGUAGE";

@Injectable()
@Component({
  selector: "app-details",
  templateUrl: "./details.component.html",
  styleUrls: ["./details.component.scss"],
})
export class DetailsComponent implements OnInit {
  selectedLang: string;
  static detailsComponent: DetailsComponent;
  @Input() CompanyName;
  @Input() BookingId;
  @Input() Fcnumber: string;
  @Input() ListType;

  select = "order";
  resize = false;
  OrderList: any = [];
  TimelineData: any = [];
  id: any;
  LatLngList: any = [];
  FromDate: any;
  // locations: {} = {
  //   DriverMobile: "",
  //   Lat: "",
  //   Lng: "",
  //   Date: "",
  // };
  ToDate: any;
  Order_no: any;
  ConsignmentNo: string;
  Status: string;
  url: string;
  ConsignmentDetailId: any;
  // change kevin 08/09/2020
  eWayBillFlag: boolean = true;
  THCFlag: boolean = true;
  // end
  //add kevin 14/06/2021
  isFreightExport: any;
  //end

  constructor(
    private service: DashboardService,
    private _appService: appService,
    public datepipe: DatePipe,
    private toastr: ToastrService,
    private service1: TranslateConfigService,
    private translate: TranslateService,
    private http: Http
  ) {
    DetailsComponent.detailsComponent = this;
    let language = this.translate.getBrowserLang();
    let value = localStorage.getItem(LNG_KEY);
    if (value === "" || value === null || value === undefined) {
      this.translate.setDefaultLang(language);
      this.selectedLang = language;
    } else {
      this.service1.setLanguage(value);
      this.selectedLang = value;
    }
    let val = localStorage.getItem(LNG_KEY);
  }

  ngOnInit() {
    // change kevin 08/09/2020
    this.eWayBillFlag = JSON.parse(localStorage.getItem("eWayBillFlag"));
    this.THCFlag = JSON.parse(localStorage.getItem("THCFlag"));
    this.isFreightExport = JSON.parse(localStorage.getItem("isFreightExport"));
    // end
    // console.log('FCnumber', this.Fcnumber);
    //this.GetTimelineDataForBooking(this.Fcnumber, this.ListType, this.BookingId, this.ConsignmentDetailId);
  }
  intilize() { }
  onSelect(s) {
    this.select = s;
  }
  onBack() {
    this.resize = !this.resize;
    this.service.changePage.emit("list");
  }

  //Getting Orders list for Current booking Id    Createde By Pawan Darji on 25/1/2020
  //GetOrderListByBookingId(Id, ListType, CustomerId);
  GetOrderListByBookingId(Id, param1, param2) {
    this._appService
      .GetByThreeId("Dashboard", "GetListOfOrderById", Id, param1, param2)
      .subscribe(
        (response) => {
          this.OrderList.push(...response);
          this.OrderList.forEach(element => {
            element.id = Id;
          });
          //console.log('order', response);
        },
        (err) => {
          this.toastr.error(err, "error");
        }
      );
  }
  //Ends Here
  //Getting Timline Data For All Bookings
  GetTimelineDataForBooking(param, param1, param2, param3) {
    this.TimelineData = [];
    this._appService
      .GetByFourId(
        "Dashboard",
        "GetTimelineDataForBooking",
        param,
        param1,
        param2,
        param3
      )
      .subscribe(
        (response) => {
          this.TimelineData.push(...response);
          console.log("timeline", this.TimelineData);
        },
        (err) => {
          this.toastr.error("Error Occured While Fetching Data", "error");
        }
      );
  }

  //tracking origin and destination
  async onTrack(pckaddress, dlvaddress, OrderNo, bookingId) {
    this.service.origin = pckaddress;
    this.service.destination = dlvaddress;
    await this._appService.GetById("Dashboard", "GetDriverMobleLocation", bookingId).subscribe((res) => {
      this.LatLngList = res as any;
      this.service.TrackLat = 0.0;
      this.service.TrackLng = 0.0;
      this.service.TrackMobile = 0;
      this.service.TrackLat = this.LatLngList[0].Lat;
      this.service.TrackLng = this.LatLngList[0].Lng;
      this.service.TrackMobile = this.LatLngList[0].DriverMobile;
      this.service.isDisplayLiveLocation = this.LatLngList[0].isDisplay;
      if (this.LatLngList[0].GPSTrackingUrl != null && this.LatLngList[0].isSIMTracking != 'YES') {
        this.getGPSLiveTrackLocation(this.LatLngList[0].GPSTrackingUrl).subscribe((data) => {
          if (data.root.VehicleData != undefined) {
            this.service.TrackLat = parseFloat(data.root.VehicleData[0].Latitude);
            this.service.TrackLng = parseFloat(data.root.VehicleData[0].Longitude);
          }
        },
          (error) => {
            this.toastr.error(error._body.replace(/"/g, ""), "Error");
          });
      } else if (this.LatLngList[0].isSIMTracking == 'YES') {
        var settings = {
          "async": true,
          "crossDomain": true,
          "url": "https://sct.intutrack.com/api/test/status?tripId=" + this.LatLngList[0].TrackingTripId,
          "method": "GET",
          "headers": {
            "authorization": "Basic c0dGMHBqMnRvcG01SzdUa05KUUhIZWxCRXQyOHROVGEzbktNVU40ajNTSUk3VVowM0hGS21ReHlXUWtiOWhQMjo1eVA4UEFhSXROUDRsNFIwNkJNRDBQQ1FpbFdlNkM2bmhlRmNjbDhGWlRIeURqWGRZRllncEQybU54OHBVTzlx",
            "content-type": "application/x-www-form-urlencoded",
            "cache-control": "no-cache",
            // "postman-token": "d27eceec-9da5-8860-264d-2f1ed626354b",
            "username": "sGF0pj2topm5K7TkNJQHHelBEt28tNTa3nKMUN4j3SII7UZ03HFKmQxyWQkb9hP2",
            "password": "5yP8PAaItNP4l4R06BMD0PCQilWe6C6nheFccl8FZTHyDjXdYFYgpD2mNx8pUO9q"
          }
        }

        $.ajax(settings).done(function (response) {
          if (response != null) {
            DetailsComponent.detailsComponent.service.TrackLat = parseFloat(response[0].loc[0]);
            DetailsComponent.detailsComponent.service.TrackLng = parseFloat(response[0].loc[1]);
          }
        })
          .fail(function (jqXHR) {
            console.log('errorThrown', jqXHR.responseText);
          });;
      }
    });
  }

  getGPSLiveTrackLocation(URL: any) {
    return this.http.get(URL).map((response: Response) => response.json());
  }

  //Sending Whatsapp Message To Customer/transporter
  onwpp(wppnumber) {
    window.open(
      `https://api.whatsapp.com/send?phone=${wppnumber}&text=IfreightBox`
    );
  }
  //calling through skype
  onskype(skypenumber) {
    window.open("tel:" + skypenumber);
  }
  //mailing customer and transporter
  onMail(mailid) {
    window.open("mailto:" + mailid);
  }
}
